// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e7-a";
export var fulfillmentFormRail = "_e7-9";
export var headerTitleRow = "_e7-c";
export var orderDetailsWrapper = "_e7-7";
export var orderLinkTrigger = "_e7-2";
export var paymentInformationGrid = "_e7-h";
export var paymentSummaryColumn = "_e7-i";
export var shipmentContainer = "_e7-b";
export var shipmentDetailsMainPane = "_e7-8";
export var shipmentNavigationCard = "_e7-5";
export var shipmentNavigationRail = "_e7-3";
export var shipmentNavigationRailHeader = "_e7-4";
export var shipmentSummaryFact = "_e7-e";
export var shipmentSummaryGrid = "_e7-d";
export var shipmentSummaryMetadataRow = "_e7-f";
export var shipmentSummaryTags = "_e7-g";
export var shipmentWorkspace = "_e7-0";
export var shipmentWorkspaceContent = "_e7-6";
export var shipmentWorkspaceHeader = "_e7-1";